<template>
  <div class="ma-2">
    <v-container>
      <v-row>
        <v-col cols="12" md="6" lg="4" v-for="user in users.all.items" :key="user.id">
          <v-card class="elevation-4" tile>
            <v-card-text>
              <h3 class="headline">
                <v-icon v-if="!user.isAdmin">person_outlined</v-icon>
                <v-icon v-if="user.isAdmin">person</v-icon>
                {{user.firstName}} {{user.lastName}} ({{user.username}})
              </h3>
              <div>{{$t('Email')}}: {{user.email}}</div>
              <div>{{$t('Created')}}: {{new Date(user.createdDate).toLocaleString("hu-HU")}}</div>
            </v-card-text>
            <v-card-actions>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn fab small dark v-on="on" color="primary" @click="editUser(user)">
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('Update user')}}</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-tooltip left>
        <template v-slot:activator="{on}">
          <v-btn
            absolute
            v-on="on"
            dark
            fab
            bottom
            right
            color="error"
            class="mb-12 mr-2"
            @click="addUser"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>{{$t('Add new user')}}</span>
      </v-tooltip>
      <UserEdit ref="userEdit" @userInfoChanged="saveChanges" @userDeleted="removeUser" />
    </v-container>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import UserEdit from "@/components/UserEdit";
import userBase from "@/components/UserBase";

export default {
  name: "Users",
  data() {
    return {
      prevRegStatus: false,
      prevUpdateStatus: false
    };
  },
  mounted() {
    this.getAll();
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      users: state => state.users,
      account: state => state.account
    })
  },
  methods: {
    ...mapActions("users", ["getAll", "delete"]),
    ...mapActions("account", ["register", "update"]),
    editUser(user) {
      this.$refs.userEdit.show(user);
    },
    addUser() {
      let user = {};
      userBase.headerList.forEach(item => {
        if (item.visibleInCreateMode) {
          if (item.type == "list") {
            user[item.paths[0].field] = [];
            user[item.paths[1].field] = [];
          } else {
            user[item.path] = "";
          }
        }
      });
      this.$refs.userEdit.show(user, true);
    },
    removeUser(user) {
      this.delete(user._id);
    },
    saveChanges(user) {
      if (user.id) {
        let userCopy = JSON.parse(JSON.stringify(user));
        if (userCopy.password === "") {
          delete userCopy.password;
        }
        this.update(userCopy);
      } else {
        user.permission = {
          isEnabled: true,
          permissions: {
            isAdmin: false,
            tableEdit: user.tableEdit,
            tableView: user.tableView
          }
        };
        this.register(JSON.parse(JSON.stringify(user)));
      }
    }
  },
  watch: {
    account: {
      handler() {
        if (this.prevRegStatus || this.prevUpdateStatus) {
          this.getAll();
        }
        this.prevRegStatus = this.account.status.registering;
        this.prevUpdateStatus = this.account.status.updating;
      },
      deep: true
    }
  },
  components: {
    UserEdit
  }
};
</script>
